import Project from "../main.js";
import {Logos} from "../components/logos.js";

export class Programmes {
	constructor() {
		this.project = new Project()

		this.DOM = {
			programmes: this.project.DOM.body.querySelector('.programmes'),
			programmesArticlesGroups: this.project.DOM.body.querySelectorAll('.tabs__nav__list_item'),
			programmesArticlesTabPanel: this.project.DOM.body.querySelector('.tabs__panel'),
			programmesArticles: this.project.DOM.body.querySelectorAll('.programmes__list__item'),
			programmesActiveGroupArticles: this.project.DOM.body.querySelectorAll('.programmes__list__item'),
			programmesToggle: this.project.DOM.body.querySelector('.programmes__actions__buttons__toggle'),
		}

		this.instances = {
			logos: new Logos()
		}

		this.init()
	}

	init() {
		this.handleEvents();
	}

	handleEvents() {
		this.DOM.programmesArticlesGroups.forEach((tabGroupBtn) => {
			tabGroupBtn.addEventListener('click', this.filterProgrammes.bind(this));

			if (tabGroupBtn.classList.contains('active')) {
				this.filterProgrammes(tabGroupBtn);
			}
		})

		this.DOM.programmesToggle?.addEventListener('click', this.toggleProgrammes.bind(this))
	}

	filterProgrammes(e) {
		const btn = e.target || e;
		const type = btn.dataset.type;

		this.DOM.programmesArticlesGroups.forEach(tabGroupBtn => {
			tabGroupBtn.classList.toggle('active', tabGroupBtn.dataset.type === type);
		});

		this.DOM.programmesArticlesTabPanel.setAttribute('aria-labelledby', btn.id);

		this.DOM.programmesActiveGroupArticles = [];
		this.DOM.programmesArticles.forEach((item) => {
			if(item.dataset.type === type) {
				this.DOM.programmesActiveGroupArticles.push(item);
			}

			item.classList.toggle('hidden', item.dataset.type !== type);
		})

		// Toggle all except first 3 items
		this.DOM.programmesActiveGroupArticles.forEach((item, index) => {
			if(index < 3) {
				return
			}

			item.classList.add('hidden')
		})

		// Reset toggle & hide toggle if <= 3 items
		this.DOM.programmesToggle.classList.remove('programmes__actions__buttons__toggle--expanded');
		this.DOM.programmesToggle.innerText = 'Rozbalit nabídku';
		this.DOM.programmesToggle.classList.toggle('hidden', this.DOM.programmesActiveGroupArticles.length < 4);
	}

	toggleProgrammes() {
		const isExpanded = this.DOM.programmesToggle.classList.toggle('programmes__actions__buttons__toggle--expanded');

		this.DOM.programmesToggle.innerText = isExpanded ? 'Sbalit nabídku' : 'Rozbalit nabídku';

		// Toggle all except first 3 items
		this.DOM.programmesActiveGroupArticles.forEach((item, index) => {
			if(index < 3) {
				return
			}

			item.classList.toggle('hidden', !isExpanded)
		})

		// Scroll to top of list if closed
		if(!isExpanded) {
			window.scrollTo(0, this.DOM.programmes.offsetTop);
		}
	}
}
